import React from 'react';
import { FormattedMessage } from 'react-intl';
import './TroubleshootingWizardInfo.scss';
export const TroubleshootingWizardInfo = ({ items }) => {
    return (<div className='troubleshooting-wizard-info'>
    {items.map((item) => {
            return <div key={item.text} className='troubleshooting-wizard-info__item'>{item.link
                    ?
                        <FormattedMessage id={item.text} values={{
                                link: (<a href={item.link.url} target="_blank">
                 <FormattedMessage id={item.link.text}/>
               </a>)
                            }}/>
                    :
                        <FormattedMessage id={item.text}/>}</div>;
        })}
    </div>);
};
